import { DateTime } from 'luxon';

const EASTERN = 'America/New_York';

/** Convert API timestamp to Eastern DateTime. Prefer TimestampMs (Unix ms) - unambiguous. */
export function toEasternDateTime(record: { TimestampMs?: number; Timestamp?: string }): DateTime {
  let ms: number;
  if (record.TimestampMs != null) {
    ms = record.TimestampMs;
  } else if (record.Timestamp) {
    const s = String(record.Timestamp);
    ms = /Z|[+-]\d{2}:?\d{2}$/.test(s)
      ? new Date(s).getTime()
      : new Date(s.replace(' ', 'T') + 'Z').getTime();
  } else {
    ms = Date.now();
  }
  return DateTime.fromMillis(ms, { zone: EASTERN });
}

interface TimespanConfig {
  interval: number;
  showHalfHours: boolean;
}

export function calculateTimeIntervals(startDateTime: DateTime, endDateTime: DateTime): TimespanConfig {
  const timeSpan = endDateTime.diff(startDateTime, 'hours').hours;
  let interval = 1;
  let showHalfHours = false;

  if (timeSpan < 24) {
    interval = 1;
    showHalfHours = true;
  } else if (timeSpan === 24) {
    interval = 1;
    showHalfHours = false;
  } else if (timeSpan <= 72) {
    interval = 3;
  } else if (timeSpan <= 168) {
    interval = 6;
  } else if (timeSpan <= 720) {
    interval = 12;
  } else {
    interval = 24;
  }

  return { interval, showHalfHours };
}

export function formatTimeLabel(timestamp: DateTime, showHalfHours: boolean): string {
  return showHalfHours ? timestamp.toFormat('h:mm a') : timestamp.toFormat('h a');
}

export function shouldShowTimeLabel(
  timestamp: DateTime,
  startDateTime: DateTime,
  interval: number,
  showHalfHours: boolean
): boolean {
  if (showHalfHours) {
    return timestamp.minute === 0 || timestamp.minute === 30;
  }
  if (timestamp.minute !== 0) return false;
  const hoursFromStart = Math.floor(timestamp.diff(startDateTime, 'hours').hours);
  return hoursFromStart % interval === 0;
}
